import PropTypes from 'prop-types';

export const contentfulPaddingType = PropTypes.oneOf([32, 64, 96, 128]);
